import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import bgImage from '../assets/Background.png';

// DEV/PROD IMAGE URL HANDLING
const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === "development";
const API_BASE = isDev ? "http://localhost:5000" : "";

export default function UniversitiesList() {
  const [universities, setUniversities] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    fetch("/api/institutes")
      .then(res => res.json())
      .then(data => {
        setUniversities(data.institutes || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div
  style={{
    padding: "36px 12px",
    minHeight: "100vh",
    backgroundImage: `url(${bgImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat"
  }}
>

      <h2 style={{ color: "#f2f2f2ff", fontWeight: 700, marginBottom: 28 }}>All Universities</h2>
      {loading && <div>Loading...</div>}
      <div style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 28
      }}>
       {universities.map(univ => {
  // Count total number of programs
  const totalPrograms = Array.isArray(univ.departments)
    ? univ.departments.reduce((acc, dep) => acc + (dep.courses?.length || 0), 0)
    : 0;

  return (
    <div
      key={univ._id}
      onClick={() => navigate(`/institute/${univ._id}`)}
      style={{
        background: "#fff",
        borderRadius: "18px",
        boxShadow: "0 4px 14px rgba(44,70,120,0.13)",
        width: 310,
        minHeight: 265,
        margin: "0 0 28px 0",
        cursor: "pointer",
        overflow: "hidden",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        transition: "box-shadow 0.22s"
      }}
    >
      {/* Cover image */}
      <div style={{
        height: "116px",
        width: "100%",
        background: "#eaf2fc",
        position: "relative"
      }}>
        <img
          src={univ.coverUrl ? API_BASE + univ.coverUrl : "/default-campus.jpg"}
          alt="Cover"
          style={{
            height: "100%",
            width: "100%",
            objectFit: "cover"
          }}
        />
        {/* University logo, positioned top-left, no border or background */}
        <img
          src={univ.logoUrl ? API_BASE + univ.logoUrl : "/default-logo.png"}
          alt="Logo"
          style={{
            position: "absolute",
            top: "14px",
            left: "14px",
            height: "52px",
            width: "52px",
            objectFit: "contain",
            zIndex: 2,
            background: "none",
            border: "none",
            borderRadius: "0"
          }}
        />
      </div>
      <div style={{ padding: "38px 18px 18px 18px", flex: 1 }}>
        {/* University Name */}
        <div style={{
          fontWeight: 700,
          fontSize: "1.13rem",
          color: "#214a6d",
          marginBottom: "6px"
        }}>
          {univ.name}
        </div>
        {/* Number of programs */}
        <div style={{
          color: "#506d8f",
          fontSize: "0.97rem",
          marginBottom: "2px"
        }}>
          {totalPrograms} programmes offered
        </div>
      </div>
    </div>
  );
})}

      </div>
      {!loading && universities.length === 0 && (
        <div>No universities found.</div>
      )}
    </div>
  );
}
